// @flow
export function setOmninavState(state: 'opened' | 'closed', liveEvent: Object = null) {
  return {
    type: 'SET_OMNINAV_STATE',
    state,
    liveEvent
  };
}
